import { Seo } from "../../components/Seo";
import { useLanguage } from "../../i18n/LanguageProvider";

/**
 * Privacy notice.
 *
 * Describes what the deployed system actually does -- which data is stored,
 * where, who can reach it, and what is deliberately not yet decided. The
 * retention section says plainly that no period has been agreed and that
 * nothing is deleted automatically, rather than quoting a figure nobody
 * has approved.
 */
export const PrivacyPage = () => {
  const { t } = useLanguage();

  const sections = [
    ["legal.privacyCollectHeading", "legal.privacyCollectBody"],
    ["legal.privacyAssessmentHeading", "legal.privacyAssessmentBody"],
    ["legal.privacyUseHeading", "legal.privacyUseBody"],
    ["legal.privacySecurityHeading", "legal.privacySecurityBody"],
    ["legal.privacyRetentionHeading", "legal.privacyRetentionBody"],
    ["legal.privacyRightsHeading", "legal.privacyRightsBody"],
    ["legal.privacyContactHeading", "legal.privacyContactBody"],
  ] as const;

  return (
    <>
      <Seo
        titleKey="meta.privacy.title"
        descriptionKey="meta.privacy.description"
      />

      <section className="gw-section">
        <div className="gw-container gw-container--narrow">
          <h1 className="gw-title">{t("legal.privacyTitle")}</h1>
          <p className="gw-note">{t("legal.privacyUpdated")}</p>

          <div className="gw-stack-lg gw-prose" style={{ marginTop: "2.5rem" }}>
            {sections.map(([heading, body]) => (
              <section key={heading}>
                <h2
                  style={{
                    fontSize: "var(--gw-text-lg)",
                    marginBottom: "0.6rem",
                  }}
                >
                  {t(heading)}
                </h2>
                <p style={{ color: "var(--gw-ink-muted)" }}>{t(body)}</p>
              </section>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};
